<div class="number-background" [style.background-image]="backgroundImage">{{number}}</div>
